import { ReactNode, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { modalClose } from '@app/store/modal/actions';

import { BasicModal } from '../../components/Modal';

interface ConfirmModalProps {
  cancelText?: string;
  closeText: string;
  content: ReactNode;
  modalId?: string;
  title: string;
  onClose?: () => void;
  onCancel?: () => void;
}

const defaultProps = {
  title: '',
};

function ConfirmModal({
  cancelText,
  closeText,
  content,
  modalId,
  title,
  onClose,
  onCancel,
}: ConfirmModalProps) {
  const dispatch = useDispatch();

  const handleClose = useCallback(() => {
    onClose?.();
    dispatch(modalClose(modalId));
  }, [dispatch, modalId, onClose]);

  const handleCancel = useCallback(() => {
    onCancel?.();
    dispatch(modalClose(modalId));
  }, [dispatch, modalId, onCancel]);

  return (
    <BasicModal
      cancelText={cancelText}
      closeText={closeText}
      content={content}
      title={title}
      onCancel={handleCancel}
      onClose={handleClose}
    />
  );
}

ConfirmModal.defaultProps = defaultProps;

export default ConfirmModal;
